import { render, staticRenderFns } from "./syllabusAndBooksInfo.vue?vue&type=template&id=2f68328d&scoped=true&"
import script from "./syllabusAndBooksInfo.vue?vue&type=script&lang=js&"
export * from "./syllabusAndBooksInfo.vue?vue&type=script&lang=js&"
import style0 from "./syllabusAndBooksInfo.vue?vue&type=style&index=0&id=2f68328d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68328d",
  null
  
)

export default component.exports